import {
  LoginInput,
  LoginResponse,
} from "../../../../src/auth/domain/model/Login.js";

import { LoginServiceClient } from "./LoginServiceClient.js";

const EXPIRATION_DATE_STORAGE_KEY = "onemap-login/expiration";

export class AutoRefreshLoginServiceClient {
  // TODO don't refer to window unless it is defined.
  // If window is not defined, store in memory rather than localStorage.
  // Let the caller pass in a storage solution, e.g. window.localStorage, and default to a memory
  // impl
  constructor(private baseClient: LoginServiceClient) {
    const expirationDateStr = window.localStorage.getItem(
      EXPIRATION_DATE_STORAGE_KEY,
    );
    if (expirationDateStr) {
      window.setTimeout(
        this.refreshLogin.bind(this),
        new Date(expirationDateStr).getTime() - Date.now(),
      );
    }
  }

  /**
   * Once successful, the client will automatically invokes the token refresh endpoint before the
   * access token expires.
   */
  async login(input: LoginInput): Promise<LoginResponse> {
    const { expires } = await this.baseClient.login(input);
    this.updateExpirationAndScheduleRefresh(expires);
    return { expires };
  }

  private updateExpirationAndScheduleRefresh(seconds: number) {
    const milliseconds = seconds * 1000;
    window.localStorage.setItem(
      EXPIRATION_DATE_STORAGE_KEY,
      new Date(new Date().getTime() + milliseconds).toISOString(),
    );
    window.setTimeout(this.refreshLogin.bind(this), milliseconds);
  }

  private async refreshLogin(): Promise<void> {
    const { expires } = await this.baseClient.refreshLogin();
    this.updateExpirationAndScheduleRefresh(expires);
  }

  /** Invalidates the current refresh token. */
  async logout(): Promise<void> {
    window.localStorage.removeItem(EXPIRATION_DATE_STORAGE_KEY);
    await this.baseClient.logout();
  }
}
